import fetcher from '../../_generic/fetcher.fn.js';

// The links
document.addEventListener('click', (e) => {

	// Ajax links
	if( e.target.getAttribute('href')?.match(/^#:~:ajax=/) ){

		e.target.classList.add('processing');

		let url = e.target.getAttribute('href').replace(/^#:~:ajax=/,'');
		fetcher(url, null, null, e.target);

		e.preventDefault();

	}

})